module.exports = __webpack_public_path__ + "c0593c93057399b9b28e62d87fa13233.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Hero/images/ian-cheng2.gif
 ** module id = 375
 ** module chunks = 0
 **/